module.exports = __webpack_public_path__ + "static/media/DeleteIcon.2595aa89.svg";